import { XMLParser, XMLBuilder } from 'fast-xml-parser';
import SHA256 from 'crypto-js/sha256';
import TimeSignature from './TimeSignature';

export default class MusicXML {
  // stream: MusicXMLNote[];
  xml: string;
  xmlContent: unknown[]; // TODO: add types for XMLBuilder.build output (parser returns array structure)
  parser = new XMLParser({ ignoreAttributes: false, preserveOrder: true });
  builder = new XMLBuilder({ ignoreAttributes: false, preserveOrder: true });
  measures: unknown[];
  timeSignatures: TimeSignature[];
  hash: string;
  hashWithTimestamp: string;

  constructor(xml: string, timeSignatures: TimeSignature[]) {
    this.xml = xml;
    this.xmlContent = this.parser.parse(xml) as unknown[];
    const scorePartwise = MusicXML.getElements(this.xmlContent as object[], 'score-partwise')[0];
    const measures = MusicXML.getElements(scorePartwise as object[], 'part')[0];
    this.measures = measures;
    this.hash = SHA256(xml).toString();
    this.hashWithTimestamp = SHA256(xml + Date.now()).toString();
    this.timeSignatures = timeSignatures;
  }

  // Duration of the measure relative to 4/4, where 4/4 == duration of 1
  measureDuration(): number {
    const timeSignature = this.timeSignatures[0];
    return timeSignature?.numerator / timeSignature?.denominator;
  }

  // Helper method for the whacky structure the XML parses to
  // TODO: get rid of this or change the interface, it's confusing
  static getElements(el: object[], childName: string): unknown[] {
    const elements: unknown[] = [];
    for (let i = 0; i < el.length; i++) {
      const child = el[i] as Record<string, unknown>;
      if (Object.prototype.hasOwnProperty.call(child, childName)) {
        elements.push(child[childName]);
      }
    }
    return elements;
  }

  // Another helper method
  static getChildIndex(el: object[], childName: string): number {
    for (let i = 0; i < el.length; i++) {
      const child = el[i] as Record<string, unknown>;
      if (Object.prototype.hasOwnProperty.call(child, childName)) {
        return i;
      }
    }
    return -1;
  }
}
